(() => {
  const initializeHeader = (scope = document) => {
    const shell = scope.querySelector('[data-flamengo-bf-header]');
    if (!shell || shell.dataset.bfReady === 'true') return;
    shell.dataset.bfReady = 'true';
    const section = shell.closest('.section-header');
    const controller = new AbortController();
    const closeHeaderOverlays = (event, except = '') => {
      const menu = shell.querySelector('header-drawer');
      if (except !== 'menu' && menu?.mainDetailsToggle?.open) {
        menu.closeMenuDrawer?.(event, menu.mainDetailsToggle.querySelector('summary'));
      }
      const search = shell.querySelector('details-modal');
      if (except !== 'search' && search?.querySelector('details')?.open) search.close?.(false);
      shell.querySelector('flamengo-navigation')?.close?.();
    };
    shell.addEventListener('click', (event) => {
      if (event.target.closest('#cart-icon-bubble')) closeHeaderOverlays(event);
      else if (event.target.closest('.header__icon--search') && !event.target.closest('details').open) closeHeaderOverlays(event, 'search');
      else if (event.target.closest('.header__icon--menu') && !event.target.closest('details').open) closeHeaderOverlays(event, 'menu');
    }, { capture: true, signal: controller.signal });
    shell.addEventListener('keydown', (event) => {
      if (event.code === 'Space' && event.target.closest('#cart-icon-bubble')) closeHeaderOverlays(event);
    }, { capture: true, signal: controller.signal });
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    desktopQuery.addEventListener('change', (event) => {
      if (!event.matches) return;
      const menu = shell.querySelector('header-drawer');
      if (!menu?.mainDetailsToggle?.open) return;
      // The mobile trigger is hidden at this breakpoint. Release its focus trap
      // and scroll lock through the existing drawer API, then focus the logo.
      const logo = shell.querySelector('.header__heading-link');
      const summary = menu.mainDetailsToggle.querySelector('summary');
      menu.closeMenuDrawer?.(event, logo || summary);
      summary?.setAttribute('aria-expanded', 'false');
    }, { signal: controller.signal });
    let scrollFrame = 0;
    const updateScrollState = () => {
      scrollFrame = 0;
      shell.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    const queueScrollState = () => {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(updateScrollState);
    };
    const updateHeight = () => {
      if (!section) return;
      const height = Math.round(section.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--flamengo-bf-header-height', `${height}px`);
    };
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(shell);
    updateHeight();
    updateScrollState();
    window.addEventListener('scroll', queueScrollState, { passive: true, signal: controller.signal });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target !== section && !event.target.contains(shell)) return;
      controller.abort();
      resizeObserver.disconnect();
      cancelAnimationFrame(scrollFrame);
    }, { signal: controller.signal });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeHeader(), { once: true });
  } else {
    initializeHeader();
  }
  document.addEventListener('shopify:section:load', (event) => initializeHeader(event.target));
})();
